import { object, string, number, boolean } from 'yup'

// Optional numeric fields are cleared to '' by plain Formik handleChange
// (not undefined), which yup's number cast otherwise turns into NaN and
// fails typeError even though the field is optional.
const optionalNumber = () =>
    number()
        .transform((value, originalValue) =>
            originalValue === '' ? undefined : value
        )
        .typeError('Precisa de ser um número')
        .nullable()

export const createVehicleSchema = () => {
    const schema = object().shape({
        brand: string().trim().required('Campo obrigatório'),
        model: string().required('Campo obrigatório'),
        licensePlate: string()
            .required('Campo obrigatório')
            .max(8, 'Só pode ter no máximo 8 digitos'),
        dateVehicle: string().nullable(),
        createdAt: string().required('Campo obrigatório'),
        numberDoors: optionalNumber(),
        numberSeats: optionalNumber(),
        motorPower: optionalNumber(),
        mileage: optionalNumber(),
        cylinder: optionalNumber(),
        sellerPrice: optionalNumber(),
        buyPrice: optionalNumber(),
        associatedCosts: optionalNumber(),
        previewCosts: optionalNumber(),
    })

    return schema
}

export const createSaleValidationSchema = () => {
    const schema = object().shape({
        dateOfSale: string().required('Campo obrigatório'),
        salePrice: number()
            .typeError('Precisa de ser um número')
            .required('Campo obrigatório'),
        client: object().shape({
            name: string().required('Campo obrigatório'),
        }),
        loan: boolean(),
        sellerUuid: string().required('Campo obrigatório'),
        loanValue: number()
            .nullable()
            .when('loan', ([loan], schema) => {
                return loan === true
                    ? schema
                          .typeError('Precisa de ser um número')
                          .required('Campo obrigatório')
                    : schema
            }),
        loanCompany: string()
            .nullable()
            .when('loan', ([loan], schema) => {
                return loan === true
                    ? schema.required('Campo obrigatório')
                    : schema
            }),
        monthWarranty: optionalNumber(),
        mileageWarranty: optionalNumber(),
        onSignedContractValue: optionalNumber(),
        onVehicleDeliveryValue: optionalNumber(),
        vehicleKilometersOnSaleDate: optionalNumber(),
        retakeVehicle: object()
            .shape({
                mileage: optionalNumber(),
                retakeValue: optionalNumber(),
            })
            .nullable(),
    })

    return schema
}

export const createEventSchema = () => {
    const schema = object().shape({
        name: string().trim().required('Campo obrigatório'),
        startDate: string().required('Campo obrigatório'),
        endDate: string().required('Campo obrigatório'),
        imageUrl: string().nullable(),
    })

    return schema
}

export const createStandSchema = () => {
    const schema = object().shape({
        name: string().required('Campo obrigatório'),
        location: string().required('Campo obrigatório'),
        address: string().nullable(),
    })

    return schema
}

export const createSupplierSchema = () => {
    const schema = object().shape({
        name: string().required('Campo obrigatório'),
        street: string().nullable(),
        address: string().nullable(),
        parish: string().nullable(),
        county: string().nullable(),
        district: string().nullable(),
        phone: string().nullable(),
        email: string().nullable(),
        nif: optionalNumber(),
    })

    return schema
}

export const createCompanySchema = () => {
    const schema = object().shape({
        name: string().required('Campo obrigatório'),
        color: string().nullable(),
        logo: string().nullable(),
    })

    return schema
}

export const createUserSchema = () => {
    const schema = object().shape({
        username: string().required('Campo obrigatório'),
        password: string().required('Campo obrigatório'),
        firstName: string().nullable(),
        lastName: string().nullable(),
    })

    return schema
}

export const createContactSchema = () => {
    const schema = object().shape({
        name: string().trim().required('Campo obrigatório'),
        status: string().required('Campo obrigatório'),
        contactUserUuid: string().required('Campo obrigatório'),
    })

    return schema
}
